import type { Content } from '../../models';

import { VisualsWithDataTypes } from '../../config/constants';

export const validateContentVersion65 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 65) {
    if (VisualsWithDataTypes.includes(type) && typeSpecific.chart) {
      typeSpecific.chart.waterfall = typeSpecific.chart.waterfall ?? {
        enabled: false,
        connectLine: {
          enabled: false,
          stroke: '#000',
          strokeWidth: 1,
          strokeDasharray: 'solid',
        },
      };
    }

    typeSpecific.version = 65;
  }

  return true;
};
